import { connect } from 'react-redux'

const storeConnect = ({ mapStateToProps, mapDispatchToProps }) => (
  connect(mapStateToProps, mapDispatchToProps)
)

export default storeConnect
